<div class="d-flex " style="margin-top: 24px;margin-bottom: 24px; margin-left: 44px">
    <div class="product-table-toolbar-block position-relative flex-grow-1 me-2" style="min-width: 0;">
    <div class=" row align-items-center">
        <div class="form-password-toggle d-flex input-group " style="width: 300px; padding-right: 13px">
            <input type="text"
                   class="form-control search-bar"
                   [(ngModel)]="searchTerm"  (ngModelChange)="onSearch()"
                   placeholder="Recherche par mot clé"/>
            <div class="input-group-append" style="margin-right: 10px;">
                    <span class="input-group-text" id="basic-addon-search1" style="color: black;"><i
                            data-feather="search" [size]="20"></i></span>
            </div>
        </div>

        <div class="product-table-filter-dropdown position-relative d-inline-block align-middle">
            <button type="button"
                    class="btn btn-outline-primary btn-icon product-table__filter-toggle"
                    (click)="toggleFilter($event)"
                    style="padding: 11px 11px !important;">
                <i data-feather="filter"></i>
            </button>

            <!-- 📦 Filter Panel (ancré sous le bouton, ouverture vers la droite) -->
            <div #filterPanel class="card filter-sidebar length p-0 " *ngIf="showFilter" style="width: 320px;max-height: 450px" (click)="$event.stopPropagation()">
        <div class="card-header d-flex justify-content-between align-items-center" style="margin-top: 2px;">
            <h4 class="card-title mb-0">Filtres</h4>
            <button type="button" class="btn btn-sm btn-icon btn-light" (click)="toggleFilter($event)" aria-label="Fermer les filtres">
                X <i class="bx bx-x"></i>
            </button>
        </div>

        <!-- 🧱 Body with scroll and sticky buttons -->
        <div class="card-body d-flex flex-column p-0"
             style="height: 350px;  box-shadow: 2px 4px 8px rgba(47, 43, 61, 0.14);">

            <!-- 🔽 Scrollable area -->
            <div class="flex-grow-1 overflow-auto p-1">
                <!-- Type -->
                <div class="mb-1">
                    <label class="form-label">Type</label>
                    <select class="form-select form-control" [(ngModel)]="filters.type" (ngModelChange)="onFilterChange()">
                        <option value="">Tous</option>
                        <option value="matériel">Matériel</option>
                        <option value="service">Service</option>
                    </select>
                </div>

                <!-- Catégorie -->
                <div class="mb-1">
                    <label class="form-label">Catégorie</label>
                    <select class="form-select form-control" [(ngModel)]="filters.categories_id">
                        <option value="">Choisissez la catégorie</option>
                        <option *ngFor="let cat of categories" [ngValue]="cat.id">{{ cat.libelle }}</option>
                    </select>
                </div>

                <!-- Marque -->
                <div class="mb-1">
                    <label class="form-label">Marque</label>
                    <select class="form-select form-control" [(ngModel)]="filters.brand">
                        <option value="">Choisissez la marque</option>
                        <option *ngFor="let brand of brands" [ngValue]="brand.id">{{ brand.libelle }}</option>
                    </select>
                </div>

                <!-- Prix unitaire -->
                <div class="mb-1 ">
                    <label class="form-label">Prix unitaire</label>
                    <div class="input-group d-flex">
                        <select class="form-select form-control w-25" [(ngModel)]="filters.priceOperator" (ngModelChange)="onFilterChange()">
                            <option value="=">=</option>
                            <option value=">">></option>
                            <option value="<"><</option>
                        </select>
                        <input type="number" class="form-control" [(ngModel)]="filters.price" (ngModelChange)="onFilterChange()"/>
                    </div>
                </div>

                <!-- TVA -->
                <div class="mb-1">
                    <label class="form-label">TVA</label>
                    <select class="form-select form-control" [(ngModel)]="filters.tva_id">
                        <option value="">Choisissez TVA</option>
                        <option *ngFor="let tva of tva" [ngValue]="tva.id">{{ tva.valeur }} %</option>
                    </select>
                </div>

                <!-- Taxes -->
                <div class="mb-1">
                    <label class="form-label">Taxes</label>
                    <select class="form-select form-control" [(ngModel)]="filters.tax_id">
                        <option value="">Choisissez taxe</option>
                        <option *ngFor="let tax of taxes" [ngValue]="tax.id">{{ tax.nom }}</option>
                    </select>
                </div>

                <!-- Code à barre
                <div class="mb-1">
                    <label class="form-label">Code à barre</label>
                    <input type="text" class="form-control" [(ngModel)]="filters.barcode"/>
                </div>-->

                <!-- Stock -->
                <div class="mb-1">
                    <label class="form-label">État de stock</label>
                    <select class="form-select form-control" [(ngModel)]="filters.stockStatus">
                        <option value="">Tous</option>
                        <option value="in">En stock</option>
                        <option value="out">En rupture</option>
                    </select>
                </div>

                <!-- Dates -->
                <div class="mb-1">
                    <label class="form-label">Date de création (De)</label>
                    <input type="date" class="form-control mb-1" [(ngModel)]="filters.dateFrom" (ngModelChange)="onFilterChange()"/>
                    <label class="form-label">Date de création (À)</label>
                    <input type="date" class="form-control" [(ngModel)]="filters.dateTo " (ngModelChange)="onFilterChange()"/>
                </div>
            </div>

            <!-- 📌 Fixed buttons -->
            <div class="pt-1 border-top d-flex pl-3 " style="gap: 15px; padding-bottom: 19px;">
                <button class="btn btn-outline-secondary" (click)="resetFilters()">Réinitialiser</button>
                <button class="btn btn-primary" (click)="applyFilters()">Appliquer</button>
            </div>
        </div>
            </div>
        </div>

        <span class="filter-summary" *ngIf="filterSummary" [title]="filterSummary">
            {{ filterSummary }}
            <i
                    class="bi bi-x"
                    style="cursor: pointer;"
                    (click)="clearFilter()">
                    </i>
        </span>

    </div>

    </div>

    <div class="col-auto ms-auto p-0" style="margin-left: auto;margin-right: 24px">
        <button class="btn btn-primary " (click)="onClick()">+ Ajouter</button>
    </div>
</div>


<div style=" border-bottom: 1px solid #eee;"></div>
<div class="table-responsive mb-1" style="height: 677px">

    <table class="table ">
        <thead class=" custom-thead">
        <tr class="align-middle">
            <th style="color: #2F2B3DE5; font-weight: 500">RÉFÉRENCE</th>
            <th style="color: #2F2B3DE5; font-weight: 500">Désignation / COULEUR / TAILLE</th>
            <th style="color: #2F2B3DE5; font-weight: 500">PRIX DE VENTE</th>
            <th style="color: #2F2B3DE5; font-weight: 500">ÉTAT EN STOCK</th>
            <th style="color: #2F2B3DE5; font-weight: 500">TVA</th>
            <th style="color: #2F2B3DE5; font-weight: 500">TAXES</th>
            <th style="color: #2F2B3DE5; font-weight: 500">FAMILLE / SOUS FAMILLE</th>
            <th style="width: 170px; color:#2F2B3DE5; font-weight: 500">ACTION</th>
        </tr>
        </thead>
        <tbody>
    <tr *ngIf="isLoading">
        <td [attr.colspan]="8" style="text-align: center; padding: 2rem;">
            <div class="spinner-border" role="status" style="color: rgba(19, 74, 211, 1)">
                <span class="sr-only"></span>
            </div>
        </td>
    </tr>

    <tr *ngIf="!isLoading && (!tableViewRows || tableViewRows.length === 0)">
        <td [attr.colspan]="8" style="text-align: center; padding: 2rem; font-weight: 500; color: #6e6e6e;">
            Pas de données à afficher
        </td>
    </tr>

        <ng-container *ngIf="!isLoading">
            <ng-container *ngFor="let row of tableViewRows | paginate: { itemsPerPage: perPage, currentPage: currentPage }">
                <!-- Ligne simple (sans ref. fabricant ou comportement historique) -->
                <tr *ngIf="row.kind === 'simple'">
                    <td class="ref cursor-pointer" style="color: #134AD3;" (click)="detail(row.product.id)">#{{ displayRefColumn(row.product) }}</td>
                    <td>
                        <span style="font-weight: 500; font-size: 15px">{{ row.product.nom }}</span>

                        <ng-container *ngIf="formatCouleurTailleLine(row.product) as couleurTaille">
                           <br/> <small style="font-size: 13px; color: #2F2B3DCC;">{{ couleurTaille }}</small>
                        </ng-container>
                    </td>
                    <td style="font-weight: 500; font-size: 15px" >{{ row.product.prix_unitaires }} TND</td>
                    <td>
          <span class="badge" [ngClass]="getStockQuantity(row.product.id) > 0 ? 'my-custom-success' : 'my-custom-danger'">
            {{ getStockQuantity(row.product.id) }} : {{ getStockStatus(row.product.id) }}
          </span>
                    </td>
                    <td style="color: #2F2B3DB2">{{ row.product.tva?.valeur }} %</td>
                    <td style="color: #2F2B3DB2">{{ getTaxesNames(row.product) }}</td>
                    <td style="color: #2F2B3DB2">{{ formatFamilleSousFamilleLine(row.product) }}</td>
                    <td>
                        <div class="d-flex" style="gap: 17px">
                            <button class="unstyled-btn" (click)="detail(row.product.id)" title="Voir le détail">
                                <i data-feather="eye" [size]="20"></i>
                            </button>
                            <div class="p-0">
                                <button class="unstyled-btn" (click)="goToEdit(row.product.id)" title="Modifier">
                                    <i data-feather="edit" [size]="20"></i>
                                </button>
                                <ng-template #modalSimple let-modal>
                                    <div class="modal-header p-0" style="background-color: transparent;">
                                        <button type="button" class=" close" style="margin-right: 5px"
                                                (click)="modal.dismiss('Cross click')" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="card-body d-flex flex-column " style="min-height: 150px; margin-bottom: 43px">
                                        <div class="flex-grow-1 overflow-auto pe-1">
                                            <h2 class="modal-title text-center mb-1"
                                                style="color: #2F2B3DE5; font-size: 24px; font-weight: 500;margin: 24px 64px;">
                                                Voulez-vous archiver le produit {{ row.product.nom }} ?
                                            </h2>
                                        </div>
                                        <div class="pt-2 d-flex justify-content-center gap-1">
                                            <button type="button" class="btn btn-primary" (click)="archiveProduct(modal)"
                                                    style="margin-right: 16px;">Confirmer
                                            </button>
                                            <button type="button" class="btn btn-grey" (click)="modal.close('Accept click')">
                                                Annuler
                                            </button>
                                        </div>
                                    </div>
                                </ng-template>
                            </div>
                            <button class="unstyled-btn" (click)="tryOpenArchiveModal(modalSimple, row.product)" title="Archiver">
                                <i data-feather="trash-2" [size]="20" class="text-danger"></i>
                            </button>
                        </div>
                    </td>
                </tr>

                <!-- Groupe : ref. fabricant commune — ligne principale (code-barres 0 / vide) + chevron -->
                <ng-container *ngIf="row.kind === 'group'">
                    <tr>
                        <td>
                            <button *ngIf="row.siblings.length" type="button"
                                    class="btn btn-link p-0 me-1 align-middle product-table__chevron" style="color: #134AD3"
                                    (click)="toggleRefFabGroup(row.refFab, $event)"
                                    [attr.aria-expanded]="isRefFabExpanded(row.refFab)"
                                    aria-label="Afficher les variantes">
                                <i class="bi" [ngClass]="isRefFabExpanded(row.refFab) ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
                            </button>
                           <span class="ref"
                                 style="color: rgba(19, 74, 211, 1); cursor: default;"
                                 title="Détail : utiliser une ligne variante (code-barres) ci-dessous">#{{ displayRefColumn(row.primary) }}</span>
                        </td>
                        <td>
                            <span style="font-weight: 500; font-size: 15px">{{ row.primary.nom }}</span>
                        </td>
                        <td style="font-weight: 500; font-size: 15px" >{{ row.primary.prix_unitaires }} TND</td>
                        <td>
          <span class="badge" [ngClass]="getRefFabGroupTotalStockQuantity(row) > 0 ? 'my-custom-success' : 'my-custom-danger'">
            {{ getRefFabGroupTotalStockQuantity(row) }} : {{ getRefFabGroupStockStatus(row) }}
          </span>
                        </td>
                        <td style="color: #2F2B3DB2">{{ row.primary.tva?.valeur }} %</td>
                        <td style="color: #2F2B3DB2">{{ getTaxesNames(row.primary) }}</td>
                        <td style="color: #2F2B3DB2">{{ formatFamilleSousFamilleLine(row.primary) }}</td>
                        <td>
                            <div class="d-flex" style="gap: 17px">
                                <button type="button"
                                        class="unstyled-btn product-table__detail--disabled"
                                        disabled
                                        title="Détail disponible sur les lignes variantes (code-barres), pas sur la ligne groupe">
                                    <i data-feather="eye" [size]="20"></i>
                                </button>
                                <div class="p-0">
                                    <button type="button"
                                            class="unstyled-btn"
                                            (click)="goToEdit(row.primary.id)"
                                            title="Modifier le produit principal de cette famille (réf. fabricant)">
                                        <i data-feather="edit" [size]="20"></i>
                                    </button>
                                    <ng-template #modalGroupPrimary let-modal>
                                        <div class="modal-header p-0" style="background-color: transparent;">
                                            <button type="button" class=" close" style="margin-right: 5px"
                                                    (click)="modal.dismiss('Cross click')" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div class="card-body d-flex flex-column " style="min-height: 150px; margin-bottom: 43px">
                                            <div class="flex-grow-1 overflow-auto pe-1">
                                                <h2 *ngIf="productsToArchive.length > 0; else modalGroupFallback"
                                                    class="modal-title text-center mb-1"
                                                    style="color: #2F2B3DE5; font-size: 24px; font-weight: 500;margin: 24px 64px;">
                                                    Voulez-vous archiver les {{ productsToArchive.length }} produit(s) de cette famille (référence fabricant « {{ row.refFab }} ») ?
                                                </h2>
                                                <ng-template #modalGroupFallback>
                                                    <h2 class="modal-title text-center mb-1"
                                                        style="color: #2F2B3DE5; font-size: 24px; font-weight: 500;margin: 24px 64px;">
                                                        Voulez-vous archiver le produit {{ row.primary.nom }} ?
                                                    </h2>
                                                </ng-template>
                                            </div>
                                            <div class="pt-2 d-flex justify-content-center gap-1">
                                                <button type="button" class="btn btn-primary" (click)="archiveProduct(modal)"
                                                        style="margin-right: 16px;">Confirmer
                                                </button>
                                                <button type="button" class="btn btn-grey" (click)="modal.close('Accept click')">
                                                    Annuler
                                                </button>
                                            </div>
                                        </div>
                                    </ng-template>
                                </div>
                                <button class="unstyled-btn" (click)="tryOpenArchiveRefFabGroup(modalGroupPrimary, row)" title="Archiver toute la famille (même référence fabricant)">
                                    <i data-feather="trash-2" [size]="20" class="text-danger"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    <!-- Variantes (même ref. fabricant) : 1re colonne = code-barres (pas la réf. interne) -->
                    <tr *ngFor="let item of row.siblings" class="product-row--variant" [hidden]="!isRefFabExpanded(row.refFab)">
                        <td class="ref cursor-pointer" style="color: #2F2B3DE5; padding-left: 2.25rem;" (click)="detail(item.id)">CàB: {{ displayCodeBarre(item) }}</td>
                        <td>
                            <span style="font-weight: 500; font-size: 15px">{{ item.nom }}</span>
                            <ng-container *ngIf="formatCouleurTailleLine(item) as couleurTaille">
                               <br/> <small style="font-size: 13px; color: #2F2B3DCC;">{{ couleurTaille }}</small>
                            </ng-container>
                        </td>
                        <td style="font-weight: 500; font-size: 15px" >{{ item.prix_unitaires }} TND</td>
                        <td>
          <span class="badge" [ngClass]="getStockQuantity(item.id) > 0 ? 'my-custom-success' : 'my-custom-danger'">
            {{ getStockQuantity(item.id) }} : {{ getStockStatus(item.id) }}
          </span>
                        </td>
                        <td style="color: #2F2B3DB2">{{ item.tva?.valeur }} %</td>
                        <td style="color: #2F2B3DB2">{{ getTaxesNames(item) }}</td>
                        <td style="color: #2F2B3DB2">{{ formatFamilleSousFamilleLine(item) }}</td>
                        <td>
                            <div class="d-flex" style="gap: 17px">
                                <button class="unstyled-btn" (click)="detail(item.id)" title="Voir le détail">
                                    <i data-feather="eye" [size]="20"></i>
                                </button>
                                <div class="p-0">
                                    <button class="unstyled-btn" (click)="goToEdit(item.id)" title="Modifier">
                                        <i data-feather="edit" [size]="20"></i>
                                    </button>
                                    <ng-template #modalVar let-modal>
                                        <div class="modal-header p-0" style="background-color: transparent;">
                                            <button type="button" class=" close" style="margin-right: 5px"
                                                    (click)="modal.dismiss('Cross click')" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div class="card-body d-flex flex-column " style="min-height: 150px; margin-bottom: 43px">
                                            <div class="flex-grow-1 overflow-auto pe-1">
                                                <h2 class="modal-title text-center mb-1"
                                                    style="color: #2F2B3DE5; font-size: 24px; font-weight: 500;margin: 24px 64px;">
                                                    Voulez-vous archiver le produit {{ item.nom }} ?
                                                </h2>
                                            </div>
                                            <div class="pt-2 d-flex justify-content-center gap-1">
                                                <button type="button" class="btn btn-primary" (click)="archiveProduct(modal)"
                                                        style="margin-right: 16px;">Confirmer
                                                </button>
                                                <button type="button" class="btn btn-grey" (click)="modal.close('Accept click')">
                                                    Annuler
                                                </button>
                                            </div>
                                        </div>
                                    </ng-template>
                                </div>
                                <button class="unstyled-btn" (click)="tryOpenArchiveModal(modalVar, item)" title="Archiver">
                                    <i data-feather="trash-2" [size]="20" class="text-danger"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </ng-container>
            </ng-container>
        </ng-container>
        </tbody>
    </table>

</div>
<!--
<div class="row d-flex mb-5">
    <div class="col-md-6 col-12">
        <div class="d-flex justify-content-between align-items-center ">
            <label for="perPageSelect" style="font-size: 15px;margin-left: 24px" class="d-flex align-items-center">Afficher
                <select id="perPageSelect" [(ngModel)]="perPage" class="form-control mx-25">
                    <option class="page-box" *ngFor="let n of pageOptions" [value]="n">{{ n }}</option>
                </select>
            </label>
        </div>
    </div>
    <div class="col-md-6 col-12 text-end">
        <div class="d-flex flex-wrap justify-content-end gap-2" style="margin-right: 24px">
            <pagination-controls
                    (pageChange)="currentPage = $event"
                    [previousLabel]="''"
                    [nextLabel]="''"
                    class="mb-0"
            ></pagination-controls>
        </div>
    </div>

</div> -->


<div class="pagination-container">
    <div class="row d-flex">
        <div class="col-md-6 col-12">
            <div class="d-flex justify-content-between align-items-center">
                <label for="perPageSelect" style="font-size: 15px; margin-left: 24px" class="d-flex align-items-center">
                    Afficher
                    <select id="perPageSelect" [(ngModel)]="perPage" (ngModelChange)="onLimitChange()" class="form-control mx-25">
                        <option class="page-box" *ngFor="let n of pageOptions" [value]="n">{{ n }}</option>
                    </select>
                </label>
            </div>
        </div>
        <div class="col-md-6 col-12 text-end">
            <div class="d-flex flex-wrap justify-content-end gap-2" style="margin-right: 24px">
                <div class="page-box"
                     [class.disabled]="currentPage === 1"
                     (click)="currentPage > 1 && changePage(1)">
                    «
                </div>
                <div class="page-box"
                     [class.disabled]="currentPage === 1"
                     (click)="currentPage > 1 && changePage(currentPage - 1)">
                    ‹
                </div>
                <div *ngFor="let page of pages"
                     class="page-box"
                     [class.active]="page === currentPage"
                     (click)="changePage(page)">
                    {{ page }}
                </div>
                <div class="page-box"
                     [class.disabled]="currentPage >= totalPages"
                     (click)="currentPage < totalPages && changePage(currentPage + 1)">
                    ›
                </div>
                <div class="page-box"
                     [class.disabled]="currentPage >= totalPages"
                     (click)="currentPage < totalPages && changePage(totalPages)">
                    »
                </div>
            </div>
        </div>
    </div>
</div>

<div style="height: 110px"></div>



